import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const selectSingleTreeProps = buildProps({
  modelValue: {
    type: [String, Number],
  },
  tree: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  nodeKey: {
    type: String,
    default: "id",
  },
  /* 配置选项  */
  defaultProps: {
    type: Object,
    default: () => {
      return {
        children: "children",
        label: "label",
        disabled: "disabled",
      };
    },
  },
  /** 是否启动筛选 */
  filterable: {
    type: Boolean,
    default: true,
  },
  /** 选项是否有最大宽度 */
  hasMax: {
    type: Boolean,
    default: true,
  },
  /* 固定高度 防止收起异常问题 */
  fixedHeight: {
    type: Boolean,
    default: false,
  },
  // 只能选中没有子项的项
  onlyEnd: {
    type: Boolean,
    default: false,
  },
} as const);

export type SelectSingleTreeProps = ExtractPropTypes<
  typeof selectSingleTreeProps
>;
